import axios from "axios";
import Vue from "vue";
export const state = {
  items: [],
  store_level: [],
  store_cart: [],
  issue_cart: [],
  store_logs: [],
  status_report: [],
  movement_report: [],
  units: [],
  requisitions: [],
  students: {},
  all_distances: {},
  requirements: {},
  save_status: false,
};
export const getters = {
  Levels: (state) => state.store_level,
  StoreItems: (state) => state.items.data,
  StoreCart: (state) => state.store_cart.data,
  IssueCart: (state) => state.issue_cart.data,
  Units: (state) => state.units,
  MovementReport: (state) => state.movement_report,
  StatusReport: (state) => state.status_report,
  StoreLogs: (state) => state.store_logs,
  AllRequirements: (state) => state.requirements,
  SaveStatus: (state) => state.save_status,
};

export const mutations = {
  SET_ITEMS(state, newValue) {
    state.items = newValue;
  },
  set_store_cart(state, newValue) {
    state.store_cart = newValue;
  },
  set_issue_cart(state, newValue) {
    state.issue_cart = newValue;
  },
  SET_UNITS(state, newValue) {
    state.units = newValue;
  },
  set_store_level(state, newValue) {
    state.store_level = newValue;
  },
  set_store_logs(state, newValue) {
    state.store_logs = newValue;
  },
  set_store_movements(state, newValue) {
    state.movement_report = newValue;
  },
  set_status_report(state, newValue) {
    state.status_report = newValue;
  },
  SET_REQUREMENTS(state, newValue) {
    state.requirements = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  addItem({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("store_items", payload)
      .then(() => {
        dispatch("fetchStoreItems");
        dispatch("fetchUnits");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Item Was Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Edit Item
  editItem({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`store_items/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchStoreItems");
        dispatch("fetchUnits");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Item ${payload.name} Was Edited Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Editing Item",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Delete Item
  deleteItem({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`store_items/${payload.id}`)
      .then(() => {
        dispatch("fetchStoreItems");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Item ${payload.name} Was Deleted Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Deleting Item",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  addCart({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("store_cart", payload)
      .then(() => {
        dispatch("fetchStoreCart");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Item Was Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  addIssueCart({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("issue_cart_store", payload)
      .then(() => {
        dispatch("fetchIssueCart");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Item Was Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Edit Cart
  editCart({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`store_cart/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchStoreCart");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Cart ${payload.name} Was Edited Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Editing Cart",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Delete Cart
  deleteCart({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`store_cart/${payload.id}`)
      .then(() => {
        dispatch("fetchStoreCart");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Cart ${payload.name} Was Deleted Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Deleting Item",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  submitCart({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("store_audit", payload)
      .then(() => {
        dispatch("fetchStoreCart");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Items Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  submitIssueCart({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("issue_store", payload)
      .then(() => {
        dispatch("fetchIssueCart");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Items Issued Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  submitLossReturn({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("loss_return", payload)
      .then(() => {
        dispatch("fetchStoreLevel");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Items Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  addRequirements({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("requirements", payload)
      .then((response) => {
        commit("SET_REQUREMENTS", response.data);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Requirements Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchStoreLevel({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get(`store_level`)
      .then((sta) => {
        commit("SET_SAVE_STATUS", false);
        commit("set_store_level", sta.data);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchStoreItems({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get(`store_items`)
      .then((sta) => {
        commit("SET_SAVE_STATUS", false);
        commit("SET_ITEMS", sta.data);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchUnits({ commit }) {
    axios
      .get(`store_units`)
      .then((sta) => {
        commit("SET_UNITS", sta.data);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchStoreCart({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get(`store_cart`)
      .then((sta) => {
        commit("SET_SAVE_STATUS", false);
        commit("set_store_cart", sta.data);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchIssueCart({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get(`issue_cart`)
      .then((sta) => {
        commit("SET_SAVE_STATUS", false);
        commit("set_issue_cart", sta.data);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchStoreLogs({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`store_logs`, payload)
      .then((sta) => {
        commit("SET_SAVE_STATUS", false);
        commit("set_store_logs", sta.data);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchStockMovements({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`stock_movements`, payload)
      .then((sta) => {
        commit("SET_SAVE_STATUS", false);
        commit("set_store_movements", sta.data);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchRequirements({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`fetch_requirements`, payload)
      .then((response) => {
        commit("SET_SAVE_STATUS", false);
        commit("SET_REQUREMENTS", response.data);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
};
